export default __webpack_public_path__ + "static/media/person_moves.618d906e.mp3";